import React, { Component } from 'react';
import './../css/Index.css';
import VisibilitySensor from 'react-visibility-sensor';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import LandingPage from './LandingPage';
// import ProgressBar from './ProgressBar';

class Index extends Component {
  render() {
    return (
      <React.Fragment>
        <LandingPage />
        <div className="container-fluid sectionColour">
          <div className="container p-2">
            <h1 className="display-6 mt-4 mb-4 colorStyle">Skills</h1>

            <div className="row">
              {/* <ProgressBar rate="90" skillName="FRONTEND" />
                                <ProgressBar rate="80" skillName="BACKEND" />
                                <ProgressBar rate="66" skillName="PROGRAMMING" /> */}

              <div className="col-lg-4 d-flex justify-content-center">
                <div style={{ width: '160px' }}>
                  <VisibilitySensor>
                    {({ isVisible }) => {
                      const percentage = isVisible ? 90 : 0;
                      return (
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                          styles={buildStyles({
                            textColor: '#FF073A',
                            pathColor: '#FF073A',
                          })}
                        />
                      );
                    }}
                  </VisibilitySensor>
                  <span className="skill_name_style">FRONTEND</span>
                </div>
              </div>

              <div className="col-lg-4 d-flex justify-content-center">
                <div style={{ width: '160px' }}>
                  <VisibilitySensor>
                    {({ isVisible }) => {
                      const percentage = isVisible ? 80 : 0;
                      return (
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                          styles={buildStyles({
                            textColor: '#FF073A',
                            pathColor: '#FF073A',
                          })}
                        />
                      );
                    }}
                  </VisibilitySensor>
                  <span className="skill_name_style" style={{ paddingLeft: '31px' }}>
                    BACKEND
                  </span>
                </div>
              </div>

              <div className="col-lg-4 d-flex justify-content-center">
                <div className="" style={{ width: '160px' }}>
                  <VisibilitySensor>
                    {({ isVisible }) => {
                      const percentage = isVisible ? 92 : 0;
                      return (
                        <CircularProgressbar
                          value={percentage}
                          text={`${percentage}%`}
                          styles={buildStyles({
                            textColor: '#FF073A',
                            pathColor: '#FF073A',
                          })}
                        />
                      );
                    }}
                  </VisibilitySensor>
                  <span className="skill_name_style" style={{ paddingLeft: '6px' }}>
                    PROGRAMMING
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="container p-2 projects">
            <h1 className="display-6 mb-4 colorStyle">Projects</h1>
            <h4>
              Liricly (
              <a href="https://github.com/likitarai1/liricly" className="worklink">
                Link
              </a>
              )
            </h4>
            <p style={{ fontWeight: '100' }}>
              A web app where we can search YouTube videos and organize in playlists.
              <br />
              <b>Tech:</b> ReactJS, NodeJS, Material UI, MySQL, Youtube API
            </p>
            <h4>
              Infant Jesus School Website (
              <a href="https://infantjesuss.com/" className="worklink">
                Link
              </a>
              )
            </h4>
            <p style={{ fontWeight: '100' }}>
              Website for a school in Ahmedabad. Worked along with a team of 3. Especially created
              toppers page and worked on the backend of site
              <br />
              <b>Tech:</b> HTML, CSS, JS, Bootstrap, PHP, MySQL
            </p>
            <h4>Catering website</h4>
            <p style={{ fontWeight: '100' }}>
              Website for a catering service in Ahmedabad
              <br />
              <b>Tech:</b> HTML, CSS, JS, Bootstrap, PHP, MySQL
            </p>
          </div>
          <div className="container p-2 projects">
            <h1 className="display-6 mb-4 colorStyle">Internship</h1>
            <h4>Mentomeet</h4>
            <p style={{ fontWeight: '100' }}>Nov, 2020 - Jan, 2021</p>
            <p style={{ fontWeight: '100' }}>
              Created "Talk to Mentor" feature along with a team of 4 where mentees could schedule a
              google meet with mentors. Also, worked on creating a Mock Test portal where users can
              attempt JEE mock test and can view their result in dashboard. (
              <a href="https://www.mentomeet.com/index" className="worklink">
                Link
              </a>
              )
            </p>
            <h4>Coder's Club</h4>
            <p style={{ fontWeight: '100' }}>Aug, 2020 - Oct, 2020</p>
            <p style={{ fontWeight: '100' }}>
              Created a platform where students can refer lecture materials conducted by coder's
              club, attempt quiz, enroll in different upcoming courses. Got significant knowledge
              about backend work in PHP.
            </p>
          </div>
          <div className="container p-2 projects">
            <h1 className="display-6 mb-4 colorStyle">Open Source</h1>
            <h4>Material UI</h4>
            <p style={{ fontWeight: '100' }}>May, 2021 - Jun, 2021</p>
            <p style={{ fontWeight: '100' }}>
              Refined the direction and spacing props and added row column spacing props to have
              better control over the component when screen resolution changes. (
              <a href="https://github.com/mui-org/material-ui/pull/26590" className="worklink">
                Link1
              </a>
              )(
              <a href="https://github.com/mui-org/material-ui/pull/26559" className="worklink">
                Link2
              </a>
              ) <br />
              Made changes in Badge component documentation (
              <a href="https://github.com/mui-org/material-ui/pull/26009" className="worklink">
                Link
              </a>
              ).
            </p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Index;
